module.exports = __webpack_public_path__ + "static/media/front_back_white_small.97fd6d2a.png";